<template>
  <div class="dish-card-editor">
    <div class="review-form">
      <div class="card-image position-relative">
        <img class="dish-edit-image blur" :src="dish.image ? dish.image : '/icons/no-dish.png'" />
        <div class="btns-wrapper">
          <ImageUploader
                  class="upload-button"
                  @success="onImageChange"
                  @start="onStartImageUpload"
                  :canDelete="dish.image == null ? false:true" @removePhoto="onDeletePhoto"
                />


        </div>
      </div>

      <div class="dish-info-edit">
        <!-- <div class="poster-block" v-if="hasPosterIntegration">
          <p
            class="c-white title-poster"
            v-if="canImportDishFromPoster"
          >{{$t('menu_settings.import_poster')}}</p>
          <p class="c-white title-poster" v-else>{{$t('menu_settings.in_poster')}}:</p>
          <PosterMenuInput
            @setPrices="setDishPrices"
            @setInfo="setDishPosterInfo"
            v-model="dish.poster_product_id"
          />
        </div> -->
        <div class="dish-title-price">
          <input
            type="text"
            class="dish-title-edit mt-0"
            :class="{
                'dish-title-edit': true,
                'mt-0': true,
                'invalid-input': !valid && !dishName
              }"
            :placeholder="$t('menu_settings.name')"
            v-model="dishName"
            id="dishNameField"
          />
          <div class="d-flex justify-content-between">
            <input
              type="number"
              class="dish-price-edit"
              :placeholder="dish.unit == 'g' ? $t('menu_settings.weight') : $t('menu_settings.volume')"
              v-model.number="dish.price_groups[0].items[0].weight"
              v-if="isSinglePriceOnly"
            />
            <input
              type="number"
              :class="{
                'dish-price-edit': true,
                'invalid-input': !valid && dish.price_groups[0].items[0].price === null
              }"
              :placeholder="$t('menu_settings.price')"
              v-model.number="dish.price_groups[0].items[0].price"
              v-if="isSinglePriceOnly"
              :disabled="blockPriceEdit"
            />
          </div>

          <textarea
            id="test"
            rows="5"
            class="dish-desc-edit"
            :placeholder="$t('menu_settings.about')"
            v-model="dishDescription"
          />

          <IngredientsInput class="card-ingredients-input" v-model="dishIngredients" />
          <button
            class="square-button"
            style="margin-bottom: 1vh; margin-top: 0; width: 100%;"
            @click="convertDescriptionToIngredients"
            v-if="isAllowedToConvertDescription"
          >{{$t('menu_settings.convert')}}</button>

          <div class="d-flex align-items-center justify-content-between">
            <h5 class="mb-0">{{$t('units.units')}}:</h5>
            <select v-model="dish.unit" :class="dish.prices.length > 1 ? '' : 'weight-select' ">
              <option value="g">{{$t('units.g')}}</option>
              <option value="l">{{$t('units.l')}}</option>
            </select>
          </div>

          <div class="d-flex align-items-start">
            <select
              v-model="dish.weighted"
              :disabled="blockPriceEdit"
              class="weighted-select w-100"
            >
              <option :value="false">{{$t('menu_settings.portions_goods')}}</option>
              <option :value="true">{{$t('menu_settings.weight_goods')}}</option>
            </select>
          </div>

          <div class="d-flex align-items-start">
            <select v-model="dish.is_excise" class="weighted-select w-100">
              <option :value="false">{{$t('menu_settings.non_excise_goods')}}</option>
              <option :value="true">{{$t('menu_settings.excise_goods')}}</option>
            </select>
          </div>

          <!-- <div class="dish-variants-edit">
            <h2>Перерахуйте варіанти:</h2>
            <div class="dish-variants" v-if="dish.prices.length > 1">
              <div class="extra columns" v-for="(price,index) in dish.prices" :key="index">
                <form @submit.prevent="onRemoveVariant(index)">
                  <div class="d-flex align-items-end">
                    <input
                      class="price-variant"
                      placeholder="Назва варіанту"
                      type="text"
                      v-model="price.variant"
                    />
                    <button class="variant-delete small" type="submit" v-if="index != 0"></button>
                  </div>
                  <div class="d-flex">
                    <input
                      class="price-value weight-size ml-0"
                      :placeholder="dish.unit == 'g' ? 'Грамаж' : 'Літраж'"
                      type="number"
                      v-model.number="price.weight"
                    />
                    <input
                      class="price-value w-25"
                      placeholder="Ціна"
                      type="number"
                      v-model.number="price.value"
                    />
                  </div>
                </form>
              </div>
            </div>
            <div class="new-variant" v-if="add_variant.active">
              <form @submit.prevent="onAddVariant">
                <input class="price-variant" type="text" v-model="add_variant.name" />
                <input class="price-value" type="number" v-model="add_variant.price" />
                <button value="submit" class="variant-confirm"></button>
              </form>
            </div>

            <button
              class="dish-variants-add"
              @click="showAddVariantUI"
              v-if="!add_variant.active"
            >+Новий варіант</button>
          </div>
          <div class="dish-modificators-edit">
            <h2>Перерахуйте додатки:</h2>
            <div class="extra" v-for="(mod,index) in dish.modificators" :key="index">
              <form @submit.prevent="onRemoveModificator(index)">
                <input class="price-variant" type="text" v-model="mod.name" />
                <input class="price-value" type="number" v-model.number="mod.price" />
                <button class="variant-delete" type="submit"></button>
              </form>
            </div>

            <div class="new-variant" v-if="add_modificator.active">
              <form @submit.prevent="onAddModificator">
                <input class="price-variant" type="text" required v-model="add_modificator.name" />
                <input class="price-value" type="number" required v-model="add_modificator.price" />
                <button value="submit" class="variant-confirm"></button>
              </form>
            </div>
            <button
              class="dish-modificators-add"
              @click="showAddModificatorUI"
              v-if="!add_modificator.active"
            >+Новий додаток</button>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageUploader from "@/components/ImageUploader.vue";

import IngredientsInput from "@/components/menu/IngredientsInput.vue";

import PosterMenuInput from "@/components/integrations/PosterMenuInput.vue";

export default {
  data() {
    return {
      add_variant: {
        active: false,
        name: null,
        price: null
      },

      add_modificator: {
        active: false,
        name: null,
        price: null
      },

      pending_uploads: {}
    };
  },
  methods: {
    onImageChange(url, upload_id) {
      const product = this.pending_uploads[upload_id];

      if (!product) return;

      this.$store.commit("menu/setProductImageByProduct", {
        url,
        product
      });
      this.$store.dispatch("menu/save");
      this.$delete(this.pending_uploads, upload_id);
    },
    onDeletePhoto() {
      this.$store.commit("menu/setProductImageByProduct", {
        url: null,
        product: this.dish
      });
    },
    onStartImageUpload(upload_id) {
      this.$set(this.pending_uploads, upload_id, this.dish);
    },
    onAddVariant() {
      if (!this.add_variant.name || !this.add_variant.price) {
        this.hideAddVariantUI();
        return;
      }

      this.$store.commit("menu/addVariant", {
        id: this.dish._id,
        variant: this.add_variant.name,
        value: this.add_variant.price
      });
      this.hideAddVariantUI();
    },
    onAddModificator() {
      if (!this.add_modificator.name || !this.add_modificator.price) {
        this.hideAddModificatorUI();
        return;
      }

      this.$store.commit("menu/addModificator", {
        id: this.dish._id,
        name: this.add_modificator.name,
        price: this.add_modificator.price
      });
      this.hideAddModificatorUI();
    },
    showAddVariantUI() {
      this.$store.commit("menu/addVariant", {
        id: this.dish._id,
        variant: null,
        value: null,
        weight: null
      });
    },
    showAddModificatorUI() {
      this.$store.commit("menu/addModificator", {
        id: this.dish._id,
        name: "",
        price: 1
      });
    },
    hideAddVariantUI() {
      this.add_variant.active = false;
    },
    hideAddModificatorUI() {
      this.add_modificator.active = false;
    },
    onRemoveVariant(index) {
      this.$store.commit("menu/removeVariant", {
        id: this.dish._id,
        index
      });
    },
    onRemoveModificator(index) {
      this.$store.commit("menu/removeModificator", {
        id: this.dish._id,
        index
      });
    },

    convertDescriptionToIngredients() {
      const desc = this.dishDescription;

      const comma_index = desc.indexOf(",");

      if (comma_index == -1) {
        alert(
          `Здається, коми відсутні в описі, конвертувати в інгрідієнти неможливо.`
        );
        return;
      }

      const tokens = desc.split(",").map(s => s.trim());

      // this.dishDescription = '';
      this.dishIngredients = tokens;
    },

    setDishPrices(prices) {
      this.$store.commit("menu/setProductData", {
        key: "prices",
        value: prices
      });
    },

    setDishPosterInfo(info) {
      this.$store.commit("menu/setProductData", {
        key: "weighted",
        value: info.weighted
      });

      if (!this.canImportDishFromPoster) return;

      this.dishName = info.name;
      this.$store.commit("menu/setProductImageByProduct", {
        url: info.image,
        product: this.dish
      });
    }
  },
  computed: {
    dish() {
      return this.$store.state.menu.product;
    },
    dishName: {
      get() {
        return this.dish.name;
      },
      set(value) {
        this.$store.commit("menu/setProductData", {
          key: "name",
          value
        });
      }
    },
    dishDescription: {
      get() {
        return this.dish.description;
      },
      set(value) {
        this.$store.commit("menu/setProductData", {
          key: "description",
          value
        });
      }
    },
    dishIngredients: {
      get() {
        return this.dish.ingredients;
      },
      set(value) {
        this.$store.commit("menu/setProductData", {
          key: "ingredients",
          value
        });
      }
    },
    dishWeight: {
      get() {
        return this.dish.weight;
      },
      set(value) {
        this.$store.commit("menu/setProductData", {
          key: "weight",
          value
        });
      }
    },
    isAllowedToConvertDescription() {
      return this.$route.query.dikey && this.$route.query.dikey == "hd20dnc2";
    },
    hasPosterIntegration() {
      return this.$store.getters.hasPosterIntegration;
    },
    blockPriceEdit() {
      return this.hasPosterIntegration && this.dish.poster_product_id;
    },
    canImportDishFromPoster() {
      return !this.dishName && !this.dishDescription;
    },
    isSinglePriceOnly() {
      const variants_group = this.dish.price_groups.filter(g => g.single_select);
      return variants_group.length == 1 && variants_group[0].items.length == 1;
    }
  },
  props: {
    valid: Boolean
  },
  components: {
    ImageUploader,
    IngredientsInput,
    PosterMenuInput
  }
};
</script>

<style scoped>
.dish-card-editor {
  position: relative;
}

.title-poster {
  font-size: 2vh;
  margin-bottom: 0;
}

.dish-info-edit {
  overflow-y: auto;
  height: 46.8vh;
  background: #1d1d1b;
  border-radius: 1.5vh;
  margin-top: 2.2vh;
  padding: 1.1vh 1.1vh 3vh;
}

.btns-wrapper {
  display: flex;
  flex-flow: column;
  width: 100%;
  position: absolute;
  height: 100%;
  top: 3%;
  justify-content: center;
  align-items: center;
}

.dish-price-edit,
.dish-title-edit,
select {
  background: #ffffff;
  border-radius: 0.8vh;
  border: 0;
  padding: 0 1.1vh;
  outline: none;
}

input {
  margin-top: 1vh;
}

select {
  height: 3.8vh;
  width: 38%;
  font-size: 2.2vh;
}

.weight-select {
  margin-left: 0.6vh;
}

.dish-desc-edit {
  width: 100%;

  background: #ffffff;
  border-radius: 0.8vh;

  font-size: 1.7vh;
  line-height: 130.8%;

  color: #1d1d1b;

  border: 0;

  margin-top: 1vh;
  outline: none;
  padding: 1vh;
}

.dish-price-edit {
  width: 49%;
  height: 4vh;
  font-weight: 500;
  font-size: 2.2vh;
  margin-top: 1vh;
  color: #000000;
}
.dish-title-edit {
  width: 100%;
  font-weight: bold;
  font-size: 2.2vh;
  height: 4vh;

  color: #000000;
}

.dish-edit-image {
  width: 100%;
  height: 21vh;
  object-fit: cover;
  border-radius: 1.5vh;
}


.blur {
  filter: blur(2px);
}

.dish-variants-edit {
  margin: 2.2vh 1.1vh;
  display: grid;
}
.dish-modificators-edit {
  display: grid;
  margin: 0 1vh;
}

.dish-variants-edit h2,
.dish-modificators-edit h2,
h5 {
  font-weight: 500;
  font-size: 1.8vh;
  color: #ededed;

  margin-bottom: 0vh;
}

.dish-variants-add,
.dish-modificators-add {
  width: 100%;
  height: 3.2vh;
  margin-top: 1.2vh;
  border: 0.06vw solid #cbd9e6;
  box-sizing: border-box;
  border-radius: 0.33vw;
  font-weight: 500;
  font-size: 1.5vh;

  color: #cbd9e6;
  background: none;

  cursor: pointer;
}
.extra form {
  display: flex;
}

.extra.columns form {
  flex-flow: column nowrap;
}

.price-variant {
  width: 100%;
  height: 3.4vh;

  background: #ededed;
  border-radius: 0.5vh;

  font-weight: 500;
  font-size: 1.7vh;
  border: 0;
  outline: none;

  color: #1d1d1b;
  padding: 0.5vh;
}

.weight-size {
  width: 73% !important;
}

.price-value {
  padding: 0.5vh;

  width: 50%;
  height: 3.4vh;

  background: #ededed;
  border-radius: 0.5vh;

  font-weight: 500;
  font-size: 1.7vh;
  border: 0;
  outline: none;

  color: #1d1d1b;

  margin-left: 0.5vh;
}

.variant-delete {
  background: url("../../assets/delete.png") center #e2223b no-repeat;
  background-size: 1.6vh;
  border: 0;
  border-radius: 0.5vh;
  margin-left: 0.5vh;
  width: 18.3%;
  margin-top: 1vh;
  height: 3.4vh;
  cursor: pointer;
}

.variant-delete.small {
  width: 11.5%;
}

.variant-confirm {
  background: url("../../assets/accept.png") center #129b81 no-repeat;

  width: 2.22vw;
  height: 2.22vw;
  border: 0;
  border-radius: 1vh;
  margin-left: 0.6vh;
  background-size: 1.18vw;
  cursor: pointer;
}

.new-variant form {
  display: flex;
}

.upload-button {
  display: block;
  margin: 0 auto;
  border: 0;
  color: #fff;
  border-radius: 0.8vw;
  font-weight: bold;
  font-size: 1vw;
  cursor: pointer;
  background-color: #464646;
}

.weighted-select {
  margin-left: 0 !important;
  margin-top: 0.5vh;
}

.card-ingredients-input {
  margin-bottom: 1vh;
}

.dish-price-edit:disabled {
  background-color: #a4a4a4;
  color: #1d1d1b;
  cursor: not-allowed;
}

.weighted-select:disabled {
  background-color: #a4a4a4;
  color: #1d1d1b;
  cursor: not-allowed;
}

.poster-block {
  margin-bottom: 2vh;
}

.invalid-input {
  border: 2px solid #e2223b;
}
</style>
